module.exports = __webpack_public_path__ + "static/media/bitmap-05@3x.eb472b26.jpg";